import React, { memo, useContext } from 'react'
import GeoContext from 'contexts/geoContext'
import Caption from 'components/Luxkit/Typography/Caption'

interface Props {
  taxesPayableAtProperty?: boolean;
  taxAmount: number;
  variant?: 'small' | 'medium' | 'large' ;
}

function TaxesAndFees({
  taxesPayableAtProperty,
  taxAmount,
  variant = 'medium',
}: Props) {
  const geo = useContext(GeoContext)

  const priceExcludesTaxesAndFees = taxAmount > 0 && (geo.showTaxExclusivePrices || !!taxesPayableAtProperty)
  const useGreenPrice = !priceExcludesTaxesAndFees && geo.showTaxExclusivePrices

  return <Caption colour={useGreenPrice ? 'highlight-secondary' : 'neutral-three'} variant={variant}>
    {priceExcludesTaxesAndFees && <>Taxes & fees apply&nbsp;</>}
    {!priceExcludesTaxesAndFees && <>Includes taxes & fees&nbsp;</>}
  </Caption>
}

export default memo(TaxesAndFees)
